import React from 'react'
import { Link } from 'react-router-dom'
import { Container, Col, Row } from 'react-bootstrap'
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

const SSGreenCta = () => {
    return (
        <section className="touch bg-2">
                <div className="bgc-2">
                    <Container>
                        <Row>
                            <Col md={9} className="my-auto">

                                <h2>Our New Firm SSN Green Energy Pvt. Ltd.</h2>
                                <p className="text-white">
  Your trusted partner delivering sustainable, innovative, and quality-focused solutions for every future-ready project.
</p>
                            </Col>
                            <Col md={3} className="text-center my-auto">
                                <Link to="/contact-us" className="btn btn-primary">Get In touch <ArrowRightAltIcon /></Link>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
    )
}

export default SSGreenCta
